// STEP MOA-LIVE-VOICE-AUTO-WHISPER-1 · 라모 AI 캡슐 내 자동 음성 제어 섹션.
import React from 'react';
import { AudioLines } from 'lucide-react';

export const AUTO_LABELS = {
  off: '자동 음성 제어 OFF · 듣고 있지 않음',
  paused: '일시 중단 · 듣고 있지 않음 (ON 으로 재개)',
  idle: '음성 대기',
  speech: '음성 감지',
  stt: 'Whisper 처리 중',
  awaiting: '호출어 인식 · 명령을 말씀하세요',
  exec: '명령 실행',
  limited: '사용량 제한 도달',
  error: '자동 제어 중지 (오류)',
};

export const RamoAutoVoicePanel = ({ auto, enabled, testIdPrefix }) => {
  const u = auto.usage;
  const d = auto.diag || {};
  return (
    <div className="rounded-lg bg-white/5 border border-white/10 px-2 py-1.5" data-testid={`${testIdPrefix}-panel-auto`}>
      <div className="flex items-center justify-between gap-2 mb-1">
        <span className="text-[10px] font-black text-white inline-flex items-center gap-1">
          <AudioLines size={10} /> 자동 음성 제어 (Whisper)
        </span>
        <button type="button" onClick={() => auto.toggle?.()} disabled={!enabled}
                className={`text-[9px] font-black px-1.5 py-0.5 rounded-full border ${
                  auto.on ? 'bg-emerald-500 text-white border-emerald-400' : 'bg-white/10 text-white/80 border-white/15'
                } ${!enabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                data-testid={`${testIdPrefix}-panel-auto-toggle`}>
          {auto.on ? 'ON' : 'OFF'}
        </button>
      </div>
      <p className="text-[10px] font-black text-white" data-testid={`${testIdPrefix}-panel-auto-phase`} data-auto-phase={auto.phase}>
        {enabled ? (AUTO_LABELS[auto.phase] || auto.phase) : '먼저 음성 명령 ON 으로 전환하세요.'}
      </p>
      {u && (
        <p className="text-[9px] text-white/60 leading-snug mt-0.5" data-testid={`${testIdPrefix}-panel-auto-usage`}>
          오늘 {u.today?.count}회 · {u.today?.seconds}초 (mock {u.today?.mock_count}) / 한도 {u.limits?.daily_requests}회 · {u.limits?.daily_seconds}초
          · 추정 Whisper ${u.est_cost_usd_today} (월 ${u.est_cost_usd_month})
        </p>
      )}
      {auto.isTestMode && (
        <input value={auto.mockText} onChange={(e) => auto.setMockText(e.target.value)}
               placeholder="Mock 전사 (| 로 구분 · 테스트 모드)"
               className="mt-1 w-full text-[9px] px-1.5 py-1 rounded bg-black/40 border border-white/15 text-white"
               data-testid={`${testIdPrefix}-panel-auto-mock-input`} />
      )}
      <details className="mt-1" data-testid={`${testIdPrefix}-panel-auto-diag`}>
        <summary className="text-[9px] text-white/60 cursor-pointer">진단</summary>
        <pre className="text-[9px] leading-snug text-white/80 whitespace-pre-wrap break-all mt-1" data-testid={`${testIdPrefix}-panel-auto-diag-body`}>
{`소스: ${d.source || '-'} · 오디오 ${d.ctxState} · 프레임 ${d.frames || 0} · 레벨 ${(d.level || 0).toFixed(3)}
API 요청(오늘 서버) ${u?.today?.count ?? 0}회 · 누적 ${u?.today?.seconds ?? 0}초 · 서버 차단 ${u?.today?.rejected ?? 0} ${u?.today?.rejected_by ? JSON.stringify(u.today.rejected_by) : ''}
이번 화면: 전송 ${d.counts?.sent || 0} · 완료 ${d.counts?.done || 0} · 차단 ${d.counts?.blocked || 0} · 실패 ${d.counts?.failed || 0} · 취소 ${d.counts?.cancelled || 0} · 만료응답 ${d.counts?.stale || 0} · 미전송 폐기 ${d.counts?.dropped || 0}
최근 전사: ${d.lastTranscript || '-'}
매칭: ${d.lastMatch ? `${d.lastMatch.matched ? 'O' : 'X'} ${d.lastMatch.alias || ''} · 명령 "${d.lastMatch.command || ''}"` : '-'}
${(d.log || []).join('\n')}`}
        </pre>
      </details>
    </div>
  );
};

export default RamoAutoVoicePanel;
